import { UPDATE_STEPS_ACTION } from '../types';

// For the status, allowed values are:
// finish, process, wait, error
export const updateStepsReducer = (state = {
    steps : [
        { name: "Login", status: "finish", description: "" },
        { name: "General Information", status: "incomplete", isCurrentStep: true },
        { name: "Invitation Card", status: "incomplete", isCurrentStep: false },
        { name: "Guest List", status: "incomplete", isCurrentStep: false },
        { name: "Generate Cards", status: "incomplete", isCurrentStep: false },
        // { name: "Preview Template", status: "wait", description: "Preview the template before generating cards." },
        // { name: "Preview Cards", status: "wait", description: "Preview the generated cards." },
        // { name: "Send Invites", status: "wait", description: "Send invites to your guests." },
        // { name: "Done", status: "wait", description: "The process is complete." }
    ]
}, action) => {
    switch (action.type) {
        case UPDATE_STEPS_ACTION:
            return {
                ...state,
                titles: action.payload,
            };
        default:
            return state;
    }
};